<script setup lang="ts">
import type { InvestigationCollectionItem } from '@nuxt/content'

const props = defineProps<{
  article: InvestigationCollectionItem
}>()

const { data: locations } = await useAsyncData(`count-locations-for-${props.article.id}`, () => {
  return queryCollection('location')
    .where('path', 'LIKE', `%${props.article.path}%`)
    .all()
}, {
  default() {
    return []
  },
})

const shouldShowLocations = computed(() => {
  return locations.value.length > 0
})

const label = computed(() => {
  return locations.value.length > 1 ? 'Locaties' : 'Locatie'
})
</script>

<template>
  <section v-if="shouldShowLocations" class="border rounded shadow border-neutral-200 dark:border-neutral-700">
    <header class="border-b border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 px-4 py-2 flex items-center">
      <h3>{{ label }}</h3>
    </header>
    <Locations :article="props.article" class="h-[20rem] md:h-[24rem] lg:h-[28rem] xl:h-[30rem]" />
    <footer class="p-4 divide-y divide-neutral-200 dark:divide-neutral-700">
      <div v-for="location in locations" :key="location.id" class="flex justify-between items-center py-2">
        <span>{{ location.title }}</span>
        <UButton variant="ghost" :to="location.path">
          Bekijk de locatie
        </UButton>
      </div>
    </footer>
  </section>
</template>
